/**
 * A CSS `url()` of any URL, quoted. An unquoted one ends at a quote, a parenthesis or a space,
 * which Vite's inlined SVG data URIs hold, and the browser then drops the whole declaration (the
 * gender icons' grey squares, #770). A double quote or a backslash in the URL is escaped.
 */
export function cssUrl(url: string): string {
  return `url("${url.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\a ")}")`;
}
